import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { AgreementCompliancePageProps } from 'pages/allTasks/TaskModal/AgreementCompliancePageProps';
import QldAgreementComplianceTypePage from './QldAgreementComplianceTypePage';
import NswAgreementComplianceTypePage from './NswAgreementComplianceTypePage';

const AgreementComplianceTypePage = (props: AgreementCompliancePageProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementComplianceTypePage {...props} />;
    case CampaignDetailModelState.NSW:
      return <NswAgreementComplianceTypePage {...props} />;
    default:
      return null;
  }
};

export default AgreementComplianceTypePage;
